import { CSSProperties, useEffect } from "react";
import FansTable from './FansTable/FansTable';
import Colors from "modules/Colors";
import Sty from "modules/Sty";
import ButtonSymphony from "elements/ButtonSymphony";
import { useHistory } from "react-router-dom";
import useFans from "Hooks/useFans";
import Loader from "elements/Loader";

const Fanbase = () => {
    const history = useHistory()
    const {
        isFirstLoad,
        fansData,
    } = useFans()

    const renderNoFansContainer = () => {
        return (
            <div className="noFansContainer" style={sty.noFansContainer}>
                <div className="noFansText" style={Sty.text18}>
                    Fans import and email / sms is coming soon!
                </div>
                <div className="noFansText" style={Sty.text16grey}>
                    Start building your fanbase by importing your email list or by adding fans manually.
                </div>
                {/* <ButtonSymphony
                    className="noFansButton"
                    onClick={() => history.push("/import-fans")}
                    style={{ marginTop: 8 }}
                >
                    Import Fans
                </ButtonSymphony> */}
            </div>
        )
    }

    const renderTableOrLoader = () => {
        if (isFirstLoad) {
            return (
                <div className="fanbaseComponentLoaderContainer" style={sty.fanbaseComponentLoaderContainer}>
                    <Loader
                        className="fanbaseComponentLoader"
                        title="Loading fans..."
                    />
                </div>
            )
        }

        if (fansData.length === 0) {
            return (
                renderNoFansContainer()
            )
        }

        return (
            <FansTable />
        )
    }

    return (
        <div
            className="fanbaseComponent"
            style={sty.fanbaseComponent}
        >
            {renderTableOrLoader()}
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    fanbaseComponent: {
        justifyContent: 'flex-start'
    },
    emailCounter: {
        color: Colors.greyDark,
        fontSize: 12
    },
    fanbaseComponentLoaderContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 250,
        width: '100%',
        borderRadius: 16,
        backgroundColor: Colors.greyLight,
    },
    noFansContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        borderRadius: 16,
        gap: 8,
        backgroundColor: Colors.purpleLightest,
    },
};

export default Fanbase;
